export enum NotificationType {
  days = 'days',
  hours = 'hours',
  minutes = 'minutes',
}
